module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent5"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 7",
      "id": "page_7",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Hailey grunted as he wedged himself into the hollow. Eva clambered up to stand on top of the log. Catching her breath, she scanned the forest but saw no movement.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The wind blew through the canopy above, causing the jigsaw shapes of the treetops to sway. Eva closed her eyes and took a deep breath. She could "), _c('i', [_vm._v("feel")]), _vm._v(" the energy that the plants and mosses gathered from the sunlight. She could sense the fear of the smaller animals hiding from the predator.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A twig snapped. Then, silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Now!")]), _vm._v(" A voice entered her mind. It may have been a turnfin or a tree, for all Eva knew, but it was all the warning she needed. As fast as a sand-sniper, she dropped to the ground as the beast lunged at her from its hiding place. It flew over Eva’s flattened body, over the log, and into the giant sundew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Be careful!” Eva said to Hailey. She scrambled over the log and pushed Hailey away from the trapped animal. The shaggy beast writhed in the sticky tentacles of the carnivorous plant. In minutes it was a tangled mass of fur and sap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though winded, Hailey seemed awestruck. “What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 8",
      "id": "page_8",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“I don’t know. I’ve never seen anything like it before.” Eva’s heart was pounding from her near miss with the beast. She couldn’t believe her trap had worked.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the thick curved horns jutting from the back of its head, the beast thrashed at the tendrils of the sundew. Its hairless face was flush with anger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Let me hold you,")]), _vm._v(" Eva heard the plant whisper to the beast. "), _c('i', [_vm._v("I shall hold you within me forever.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The beast roared in response.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We should leave.” Eva backed away from the trapped animal. “I don’t want to be anywhere near here if it should free itself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey’s gaze shifted between the beast and Eva.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The way you stood your ground, then tricked that thing…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva turned back to look at the trapped beast. “I… I’m sorry, Hailey…. I didn’t know what else—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Eva.” Hailey climbed up onto the log where Eva had stood, as if to reenact the scene. “That was… You were… amazing! I mean, look at those claws. It would have torn us to pieces and eaten us alive if it had caught us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva couldn’t look back at the beast. It was, after "), _c('span', {
    attrs: {
      "aria-label": "page 9",
      "id": "page_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("all, a creature of the forest doing what it needed to survive. She climbed over the log and started back down the route they had taken. “Come on. Let’s go.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey took a last look at the beast before jogging up alongside Eva. “I wish I had my Omnipod. I would have loved to see what Identicapture thought of…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Wait.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another voice entered Eva’s mind, muting out Hailey’s words. Eva stopped and looked back at the sundew. The beast was no longer struggling. It let out a low growl. In that growl Eva heard words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Free me.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ll kill us, then eat us,” Eva spoke aloud to the creature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eva?” Hailey stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Not eat you. Feed.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, then you’ll "), _c('i', [_vm._v("feed")]), _vm._v(" on us.” Eva started back toward the beast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eva, wait a nano.” Hailey went to stop her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Not feed me. Feed my pups.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Feed your pups? Then you’re a… you’re their—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva put her head in her hands. “Of course,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 10",
      "id": "page_10",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Hailey joined her atop the log. They both looked down at the beast. Piercing lemon eyes watched them, causing Eva’s hair to stand on end.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eva, I don’t know what this thing is telling you,” Hailey said, “but we need to leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Free me. I will leave.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva stepped cautiously toward the beast. “You won’t eat us?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("I will not eat you.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey remained on top of the fallen log. “Um, I’m going to repeat what you just said two minutes ago about not wanting to be near here if this thing gets free.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No eating? You promise?” Eva came closer to the beast. She could see the burns on its face where the sticky secretions of the sundew had begun to take effect. Eva knew the animal’s predicament all too well. After all, she had been snared in the gooey grip of a giant sundew once before. Fortunately, her friend Rovender Kitt had come to cut Eva free before she’d become plant food.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("I will not eat you,")]), _vm._v(" the beast said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey jumped down next to Eva.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Eat him!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The beast snapped opened its toothy jaws and spat a stream of brown liquid at Hailey. He threw "), _c('span', {
    attrs: {
      "aria-label": "page 11",
      "id": "page_11",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("up his hands to protect his face, but his forearms became covered in thick mucus.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey groaned in pain and dropped to the ground. He began scraping the mucus off his arm and onto the log. “It’s burning! It’s burning! It’s some kind of acid!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva knelt down next to Hailey to inspect the wound. The smell of scorched hair and skin assaulted her nose. She stood up to face the forest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Someone—anyone—please help me! What cures the venom of this creature?” she called out to the forest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The trees creaked in the breeze. Unseen insects chirped from their cover. Somewhere in the distance a turnfin called out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey was still conscious despite his fading pallor. Eva’s mind raced. "), _c('i', [_vm._v("Burns… burns… what would Rovender do for a burn?")]), _vm._v(" She remembered the rope burn he’d suffered from Besteel’s snare. "), _c('i', [_vm._v("What did he use?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva located a large patch of rich green moss growing nearby on the forest floor. As she pulled a clump from the soil, water dribbled from the moss as if it were a sponge. "), _c('i', [_vm._v("If it holds water like a sponge, perhaps it can also soak up liquids,")]), _vm._v(" she "), _c('span', {
    attrs: {
      "aria-label": "page 12",
      "id": "page_12",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("thought. Eva wrung the clump of moss until it was dry. She knelt down next to Hailey and carefully placed the moss on his arm. “Press this against the burn,” she said softly. “It may draw the poison out of your skin.” Hailey moaned in reply and did as instructed.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hope this works.” Eva wriggled her finger into a frayed hole in the sleeve of her coveralls. With a quick yank she tore off the cuff. “I have no idea what sort of venom this is.” She began wrapping the fabric cuff around Hailey’s arm, binding the moss to his wound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not too tight!” he said, flinching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry.” Eva continued gingerly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s never an Omnipod when you need one,” he whispered with a weak smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re better without it. Trust me. Besides, it would have just slowed things down,” Eva said. “Please initiate Individual Medical Assistance,” she imitated the Omnipod’s calm voice. She chuckled to herself while she kept wrapping Hailey’s burns. “By the time I’d gone through all of that, your arms would have burned off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, keeping my arms would be good. Don’t let me stop you,” Hailey replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, sit still. I’m almost—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 13",
      "id": "page_13",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("You live. I die.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The trapped beast’s voice drifted back into Eva’s mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about: you live, I live?” Eva said aloud. She turned and shot a hateful glare at the animal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the sundew’s stalked tentacles, digestive sap oozed to cover the beast’s unmoving body. Its face now glistened in the afternoon light. Sap dripped down over the animal’s eyes, causing them to close.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("You die. I live.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The beast’s words seemed different to Eva now. It was as if the voice of the beast had become the voice of the plant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva turned away toward Hailey and tied off his binds. “Can you walk?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. I think so.” Hailey winced as he sat up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva helped him to stand. Together they hobbled away from the dying beast.")]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After hiking through the wood for some time in silence, Eva stopped and closed her eyes. She cocked her head, listening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is it now?” Hailey glanced around with a worried look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shhh,” Eva said. “Before we leave here… I want "), _c('span', {
    attrs: {
      "aria-label": "page 14",
      "id": "page_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("to…” She focused with all of her senses, which came together as if to form a living entity. This entity zoomed through the brush and trees, like a bodiless flying eye, allowing Eva to see. Not only that, but she tasted the minerals of water as trees stretched their roots down into the damp soil. She felt the anticipation of several fledglings, still huddled in their nest with mouths open wide, as their father brought food to them. She hummed to the deep resonating sounds of something beyond her vision, a sound lower in pitch than all the creatures of the forest. Still, she kept searching through the forest…")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you okay?” Hailey gently shook Eva.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes fluttered open and focused on Hailey’s concerned face. “I’m fine. I was trying… to locate the cubs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The cubs?” Hailey gave a puzzled look. “Wait a nano. The cubs of that… thing?” He pointed back from where they’d traveled. “The horrible spitting monster thing that just tried to kill us?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva looked down. “Yes. I just didn’t want them to… die. Without a mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I see.” Hailey folded his arms, but the movement caused him to cringe in pain. “So you want to rescue them so they can grow up and be a "), _c('span', {
    attrs: {
      "aria-label": "page 15",
      "id": "page_15",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("whole pack")]), _vm._v(" of horrible spitting monsters that want to kill us. Is that it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, Hailey. I… I guess you’re right,” Eva said, embarrassed. “Come on. Let’s go back to camp.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No rescuing spitting-monster babies?” Hailey wagged a finger at her playfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva nodded. “I promise.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-591bf8fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781481403887/xhtml/ch01_sub02.vue
// module id = 87
// module chunks = 0